// extracted by mini-css-extract-plugin
module.exports = {"item":"item--Awvy0","reverse":"reverse--3Re34","textWrap":"textWrap--2cI9F","imageWrap":"imageWrap--1YdN-"};